import React from 'react';
import CharactersContainer from './CharactersContainer';
import useThreeConvaiClient from '../../hooks/useThreeConvaiClient';
import useVoiceModeListener from '../../hooks/useVoiceModeListener';

function ThreeConvaiClient() {
  const { client } = useThreeConvaiClient();
  useVoiceModeListener();

  return <CharactersContainer client={client} />;
}

export default ThreeConvaiClient;
